import { render } from "./AddEmployee.vue?vue&type=template&id=2084a3ec&scoped=true"
import script from "./AddEmployee.vue?vue&type=script&lang=js"
export * from "./AddEmployee.vue?vue&type=script&lang=js"

import "./AddEmployee.vue?vue&type=style&index=0&id=2084a3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2084a3ec"]])

export default __exports__